<template>
  <div>
    <trustpilot-widget />
    <v-app-bar
      v-if="showHeader"
      v-sticky="stickyHeader"
      :sticky-z-index="6"
      clipped-left
      class="site-header elevation-1 justify-between"
      :color="partnerHeaderColor"
      :height="localHeaderHeight"
      :style="{ '--height': localHeaderHeight + 'px' }"
    >
      <header-logos />
    </v-app-bar>
  </div>
</template>

<script>
import HeaderLogos from '@/components/HeaderLogos.vue';
import TrustpilotWidget from '@/components/TrustpilotWidget/TrustpilotWidget.vue';

export default {
  name: 'site-header',
  inject: ['config'],
  props: {
    isStatic: {
      type: Boolean,
      default: false,
    },
    sidebarBreakpoint: {
      type: Object,
      default: null,
    },
  },
  components: {
    HeaderLogos,
    TrustpilotWidget,
  },
  computed: {
    showHeader () {
      return this.config.showHeader ?? true;
    },
    partnerHeaderColor () {
      return this.config.partnerHeaderColor || '#fff';
    },
    localHeaderHeight () {
      let headerHeight = this.config.headerHeight;
      if (!headerHeight) {
        headerHeight = 75;
      }
      return +headerHeight < 64 ? 64 : +headerHeight;
    },
    stickyHeader () {
      if (this.isStatic) return false;

      if (this.sidebarBreakpoint) {
        return this.sidebarBreakpoint.andUp;
      }
      return this.$vuetify.breakpoint.lgAndUp;
    },
  },
};
</script>

<style lang="scss" scoped>
.site-header {
  &::v-deep {
    .v-toolbar {
      &__content {
        padding: calc(0.2 * var(--height)) 0 !important;
      }
    }
  }
}
</style>
